<div *ngIf="!nameservers || website?.isNetwork || isClone" class="db-create-website-success__general">
  <h2 class="mb10 text-center">{{'text_congratsFromManager' | dbText}}</h2>
  <p class="text-center">{{'text_websiteInstalledSuccess' | dbText: {companyName: companyName} }}</p>

  <div class="db-create-website-success__content mt30 mb30">

    <div class="db-create-website-success__steps mr10">
      <div class="db-steps__title mb20">{{'text_nextSteps' | dbText}}</div>

      <div class="db-steps-wrap">
        <div class="db-steps" *ngFor=" let step of steps">
          <img class="db-icon" src="assets/images/icons/checkmark-with-border.svg" alt=""/>
          <span class="db-step">{{ step | dbText }}</span>
        </div>
      </div>
    </div>

    <img src="assets/images/other/success-image.png" alt=""/>
  </div>

  <div class="text-right">
    <button class="ds-btn-blue" (click)="closeModal()">
      <span>{{'text_letsStart' | dbText}}</span>
    </button>
  </div>
</div>

<!--Name Servers-->
<div *ngIf="nameservers && !website.isNetwork" class="db-create-website-success__nameservers">
  <h2 class="mb10">{{'text_congratsFromManager' | dbText}}</h2>
  <div class="mb30">
    <p class="mb40">{{'text_justInstalledSiteOnHosting' | dbText: {companyName: companyName} }}</p>

    <p class="mb15"><b>{{'text_nameserversLabel' | dbText}}</b></p>

    <div class="db-create-website-success__nameservers-wrap mb30">
      <div *ngFor="let nameserver of nameservers; let i = index">
        <span class="circle"></span>
        <div class="db-create-website-success__nameservers-wrap-row">
          <span [innerHTML]="nameserver"></span>
          <a class="db-install-website-success__icon" ngxClipboard [cbContent]="nameserver" (cbOnSuccess)="copiedNameServer(i)" dbInfoTooltipHover  [dbInfoTooltipHoverPosition]="'top'" [dbInfoTooltipHoverBody]="'Copy'" [smallTooltip]="true"
             *ngIf="!isCopied[i]">
            <i class="db-icon db-icon-copy"></i>
          </a>
          <a class="db-install-website-success__icon" *ngIf="isCopied[i]"  dbInfoTooltipHover  [dbInfoTooltipHoverPosition]="'top'" [dbInfoTooltipHoverBody]="'Copied'" [smallTooltip]="true" >
            <i class="db-icon db-icon-copy"></i>
          </a>
        </div>
      </div>
    </div>

    <p class="mb15" [innerHTML]="'text_replaceDefaultNameservers' | dbText: {companyName: companyName}"></p>
  </div>

  <div class="text-right">
    <button class="ds-btn-blue" (click)="closeModal()">
      <span>{{'text_done' | dbText}}</span>
    </button>
  </div>
</div>
